module.exports = __webpack_public_path__ + "img/user-red.2ea39c14.svg";